import React from 'react';

import mixin from 'react-mixin';

import { forwardPropsToState } from 'utils/react_utils';
import { FormAPI } from 'lecom-api';

@mixin.decorate(window.CssClassMixin)
@mixin.decorate(window.InputComponentMixin)
@forwardPropsToState([
	{ prop: 'value' },
	{ prop: 'checked' },
])
export default class InputCheckbox extends React.Component {
	static defaultProps = {
		themeClassKey: 'input.checkbox'
	};

	componentDidMount() {
		if (this.props.value !== undefined && this.props.value !== null && this.props.value !== "") {
			this.updateState(this.props.value ? true : false, false);
		}
	}

	componentDidUpdate(prevProps, prevState) {
		setTimeout(() => { this.tabOrderCheck() }, 100);
	}

	computeValue(checked) {
		return checked ? this.props.valueWhenChecked : '';
	}

	tabOrderCheck(){
		let idField = this.props.gridFormParent === null ? this.props.id : null;
		let idFieldGrid = this.props.gridFormParent ? this.props.id : null;
		const formAPI = FormAPI.form(this.props.formId);

		if(idField){
			let fieldDisabled = formAPI.fields(idField).disabled();
			let fieldReadOnly = formAPI.fields(idField).readOnly();
			let label = $(`#input__${idField} label`);
			let propsDisabled = this.props.disabled;
			let inputCheckbox = $(`#input__${idField} input`);
			let propsInputCheck = inputCheckbox.attr('disabled') ? true : false;

			if(fieldDisabled !== true && propsDisabled !== true){
				label.attr('tabindex', 0);
				if(propsInputCheck !== true && fieldReadOnly !== true){
					label.attr('tabindex', 0);
				} else { label.off('keydown'); }
			} else {
				label.off('keydown');
				label.attr('tabindex', '-1');
			}
		}
		else if(idFieldGrid){
			let idGrid = this.props.gridFormParent;
			let fieldGridDisabled = formAPI.grids(idGrid).fields(idFieldGrid).disabled();
			let fieldReadOnly = formAPI.grids(idGrid).fields(idFieldGrid).readOnly();
			let propsDisabled = this.props.disabled;

			let label = $(`#input__${idFieldGrid} label`);
			let inputCheckbox = $(`#input__${idFieldGrid} input`);
			let propsInputCheck = inputCheckbox.attr('disabled') ? true : false;

			if(fieldGridDisabled !== true && propsDisabled !== true){
				label.attr('tabindex', 0);
			}
			else {
				label.off('keydown');
				label.attr('tabindex', '-1');
			}
		}
	}

	executeUpdateStoreValuesCallback(isPublishEvents=true) {
		const { checked, value } = this.state;
		this.props.onCheck(checked, value, isPublishEvents);
	}

	updateState(checked, isPublishEvents=true) {
		this.setState({ checked, value: this.computeValue(checked) }, () => this.executeUpdateStoreValuesCallback(isPublishEvents));
	}

	handleChange(event) {
		if (event.isDefaultPrevented()) return;
		this.updateState(event.target.checked);
	}

	render () {
		return (
			<input
				{...this.props}
				disabled={this.props.disabled || this.props.readOnly}
				checked={this.state.checked}
				aria-checked={this.state.checked}
				value={this.state.value}
				className={`${this.inputClassName()} filled-in component-checkbox`}
				onChange={this.handleChange.bind(this)}
				type="checkbox"
				ref="input"
			/>
		);
	}
}
